import styled from "styled-components";
import { responsive } from "Styles/Constants";
import { COLORS } from "Styles/Constants";


export const TestimonialsPageContainer = styled.div`
  font-family: "Outfit", sans-serif;

.testimonials_content_wrapper {
    padding: 100px 0;
}
.testi_heading {
    margin-bottom: 50px;
}

@media (max-width: 1199px) {

}

@media (max-width: 1024px) {
    .testimonials_content_wrapper {
        padding: 70px 0;
    }
}

@media (max-width: 767px) {
    .testimonials_content_wrapper {
        padding: 50px 0;
    }
}

`;
